/**
 * Builds a mixpanel event constructor.
 *
 * @param {string} eventName - The mixpanel event name
 * @returns {Function} Builder for enriched big query event
 */
export const buildMixpanelEvent = (eventName) => (params) => buildBaseEvent(eventName, params);

/**
 * Builds a base mixpanel event constructor.
 *
 * @param {string} eventName - The mixpanel event name
 * @param {Object} params - The mixpanel event parameters
 * @returns {Object}
 */
const buildBaseEvent = (eventName, params = {}) => ({
    eventName,
    ...params,
});
